import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateLottery = (params) => {
    return axios.post(`${backendHost}/api/admin/lottery/create`, params);
};

export {
    postCreateLottery
}